<template>
  <confirm-action-dialog
    v-if="dialogModel"
    width="700"
    :persistent="true"
    :supressKeyboardActions="true"
    :title="$t(title)"
    :isDialogActive.sync="dialogModel"
    :rightText="$t('save')"
    :loading="isLoading"
    :rightLoading="isLoading"
    :rightDisabled="!isFormValid"
    @leftClick="close"
    @close="close"
    @rightClick="onRightClick"
  >
    <v-form v-model="isFormValid">
      <person-phone-form v-model="value" />
    </v-form>
  </confirm-action-dialog>
</template>
^
<script lang="ts">
import { IDialog } from "@/lib/interfaces/dialog.interface";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { IPersonPhone } from "@/models/person-phone.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync } from "vue-property-decorator";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import PersonPhoneForm from "./PersonPhoneForm.vue";

@Component({
  components: {
    PersonPhoneForm,
    ConfirmActionDialog
  },
  filters: {}
})
export default class PersonPhoneDialog extends mixins(PartnerFallbackMixin) implements IDialog {
  @Prop() value!: IPersonPhone;
  @Prop({ default: "components.partner.PersonPhoneDialog.title" }) title!: string;
  @PropSync("isDialogActive", { type: Boolean, required: true }) dialogModel!: boolean;

  isLoading = false;

  isFormValid = false;

  isDialogActive = false;

  open() {
    this.dialogModel = true;
  }

  close() {
    this.dialogModel = false;
  }

  onRightClick() {
    this.$emit("save", this.value);
    this.close();
  }
}
</script>
